import { ProductPickup } from '../../../products/types';

type rawType = {
  [key: string]: string | boolean | number;
} | null;

export const serializeProductPickup = (
  props: rawType
): ProductPickup => {
  return { ...props } as ProductPickup;
};
